'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  watch: {
    '$i18n.locale': {
      handler: function handler(val) {
        var _this = this;

        // 根节点全部被v-if掉了
        this.$nextTick(function () {
          if (_this.$el.nodeType !== 1) return;
          _this.$el.setAttribute('lang', val);
        });
      },

      immediate: true
    }
  }
};